import PageHeading from '../components/PageHeading';
import { Shield } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * 隐私政策页面
 */
function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-canvas">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        {/* 返回按钮 */}
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-muted hover:text-ink mb-6 transition-all duration-300"
        >
          <ArrowLeft size={20} />
          返回
        </button>

        {/* 标题 */}
        <PageHeading Icon={Shield} eyebrow="LEGAL · 隐私政策" title="隐私政策" description="生效日期：2026年3月23日" />

        {/* 内容 */}
        <div className="prose prose-gray max-w-none">
          <p className="text-muted mb-6">
            AI 大师兄高度重视您的隐私安全。本政策旨在说明我们如何收集、使用和保护您的个人信息。
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-ink mb-4">1. 我们收集的信息</h2>
            <div className="space-y-3 text-muted">
              <p>为了提供充值和交付服务，我们仅收集最必要的"最小化"数据：</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  <strong className="text-ink">订单信息：</strong>商户订单号、交易金额、交易时间（用于核对支付结果）。
                </li>
                <li>
                  <strong className="text-ink">联系方式：</strong>您主动填写的邮箱地址（用于接收账号信息）。
                </li>
                <li>
                  <strong className="text-ink">网络数据：</strong>访问我们网站时的基础日志（如 IP 地址、浏览器类型），用于安全防护和防止恶意攻击。
                </li>
              </ul>
              <p className="bg-brand-soft border-l-4 border-brand p-4 mt-4">
                <strong className="text-ink">重要声明：</strong>我们<strong>不会</strong>收集或存储您的敏感支付信息（如银行卡号、支付密码）。所有的支付流程均通过支付宝/微信支付/信用卡等第三方加密通道完成。
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-ink mb-4">2. 信息的使用</h2>
            <div className="space-y-3 text-muted">
              <p>我们收集的信息仅用于以下用途：</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>处理您的订单并交付虚拟商品（如账号信息）。</li>
                <li>在交易出现异常时与您取得联系。</li>
                <li>改善网站的用户体验和安全性。</li>
                <li>防止欺诈和滥用行为。</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-ink mb-4">3. 信息共享</h2>
            <div className="space-y-3 text-muted">
              <p className="font-semibold text-ink">我们承诺：绝不出售您的个人信息给任何第三方。</p>
              <p>我们仅在以下必要情况下共享数据：</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  <strong className="text-ink">支付处理：</strong>与支付网关（支付宝/微信/信用卡支付服务商）共享必要的订单号和金额以完成交易。
                </li>
                <li>
                  <strong className="text-ink">法律要求：</strong>在法律法规要求或政府机关依法要求的情况下，我们可能需要披露您的信息。
                </li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-ink mb-4">4. 数据安全</h2>
            <div className="space-y-3 text-muted">
              <p>我们采取以下措施保护您的个人信息：</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>使用 HTTPS 加密传输保护数据安全。</li>
                <li>定期进行安全审计和漏洞扫描。</li>
                <li>限制员工访问个人信息的权限。</li>
                <li>订单信息仅保留必要的时间，过期后自动删除。</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-ink mb-4">5. Cookie 技术</h2>
            <div className="space-y-3 text-muted">
              <p>本网站可能使用 Cookie 或类似技术来记录您的登录状态或语言偏好，以便为您提供更流畅的访问体验。</p>
              <p>您可以在浏览器设置中随时清除 Cookie，但这可能影响部分功能的正常使用。</p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-ink mb-4">6. 您的权利</h2>
            <div className="space-y-3 text-muted">
              <p>您对自己的个人信息享有以下权利：</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  <strong className="text-ink">访问权：</strong>您有权要求查看我们持有的关于您的个人信息。
                </li>
                <li>
                  <strong className="text-ink">更正权：</strong>如发现信息有误，您可以要求我们更正。
                </li>
                <li>
                  <strong className="text-ink">删除权：</strong>在特定情况下，您可以要求我们删除您的个人信息。
                </li>
              </ul>
              <p>如需行使上述权利，请通过 ricky@savvyai.plus 联系我们。</p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-ink mb-4">7. 未成年人保护</h2>
            <div className="space-y-3 text-muted">
              <p>我们的服务面向成年人。如果您未满18周岁，请在监护人的陪同下使用本服务。</p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-ink mb-4">8. 政策更新</h2>
            <div className="space-y-3 text-muted">
              <p>我们可能会不时更新本隐私政策。更新后的版本将在本页面发布，重大变更我们将通过显著方式通知您。</p>
              <p>建议您定期查看本页面以了解最新的隐私保护措施。</p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-ink mb-4">9. 联系我们</h2>
            <div className="space-y-3 text-muted">
              <p>如对本隐私政策有任何疑问或建议，请通过以下方式联系我们：</p>
              <p>
                <strong className="text-ink">网站：</strong>getpro.plus<br />
                <strong className="text-ink">电子邮件：</strong>ricky@savvyai.plus
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
